import React from 'react';
import { SidebarWidget } from '@material-bank/navigation-sidebar-widget';
import { createRoot } from 'react-dom/client';

const sidebarRootSelector = document.getElementById('sidebar-root');
if (sidebarRootSelector) {
  createRoot(sidebarRootSelector).render(<SidebarWidget />);
}
